<template>
  <section>
    <md-button
      class="md-primary md-raised"
      :disabled="!isLoginEnabled"
      @click="login"
      >Login</md-button
    >
  </section>
</template>

<script>
import { eventBus } from "../../eventbus";

export default {
  name: "LoginDialogActions",
  data: function () {
    return {
      emailAddress: null,
      isLoginEnabled: false,
    };
  },
  methods: {
    login: function () {
      // Emit login event, that would submit the signin form
      eventBus.submitLoginForm();
      this.isLoginEnabled = false;
    },
  },
  created: function () {
    var self = this;

    eventBus.$on("login-email-valid", function (isValid) {
      console.log("login-email-valid", isValid);

      self.isLoginEnabled = isValid;
    });
    eventBus.$on("magic-link-sent", function () {
      self.isLoginEnabled = false;
    });
  },
};
</script>

<style>
</style>